import React from "react";
import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import {
  DeleteEntityModal as _DeleteEntityModal,
  EditEntityModal as _EditEntityModal,
} from "routes/entity/components/Modals";

const DeleteEntityModal = withRoleCheck(_DeleteEntityModal, [
  ACL_RELATIONSHIPS.entity.delete,
]);
const EditEntityModal = withRoleCheck(_EditEntityModal, [
  ACL_RELATIONSHIPS.entity.edit,
  ACL_RELATIONSHIPS.user.read,
]);

export const EntityTableActions = ({
  entityId,
  fetchEntities,
  onConfirmDelete,
}) => {
  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        <EditEntityModal entityId={entityId} fetchEntities={fetchEntities} />
        <DeleteEntityModal
          onConfirmDelete={() => onConfirmDelete(entityId)}
          menuTrigger
        />
      </Dropdown.Menu>
    </CustomDropdown>
  );
};
